import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-screen h-full bg-white fixed left-0 top-0 z-50 overflow-auto" }
const _hoisted_2 = {
  id: "banner",
  class: "shadow-md w-full sticky top-0 z-50"
}
const _hoisted_3 = { class: "flex items-center relative" }
const _hoisted_4 = { class: "sm:text-[16px] text-[12px]" }
const _hoisted_5 = { class: "flex flex-col gap-3 p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Banner = _resolveComponent("Banner")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Banner, {
          hiddenIcon: !_ctx.hasIcon,
          image: _ctx.headerInfo?.icon,
          title: _ctx.headerInfo?.title,
          subtitle: _ctx.headerInfo?.subtitle,
          class: "w-full"
        }, _createSlots({ _: 2 }, [
          (!_ctx.hiddenCloseButton)
            ? {
                name: "content",
                fn: _withCtx(() => [
                  _createVNode(_component_Button, {
                    class: _normalizeClass(`${
                _ctx.closeDanger ? 'btn-delete-block' : 'btn-primary'
              } w-[60px] h-[20px] sm:w-[100px] sm:h-[40px] rounded-md flex items-center justify-center p-0`),
                    onClick: _ctx.onClose
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", { pt: "Fechar", en: "Close" })), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["hiddenIcon", "image", "title", "subtitle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}